const enums = {
  routeStatus: ['预订中', '预订结束', '售罄'],
}

export default (value, type) => enums[type][value - 1]



// WEBPACK FOOTER //
// ./client/utils/filter.js